// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__779Nd","movieImages":"MovieCard_movieImages__K-Ozt"};